// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_8GN","cls2":"PremiumBadge-cls2_H43 PremiumBadge-cls1_8GN"};